









import { Component, Vue } from "vue-property-decorator";
import HelloWorld from "@/components/HelloWorld.vue"; // @ is an alias to /src
import About from "../views/About.vue";
import Contact from "../views/Contact.vue";

@Component({
  components: {
    HelloWorld,
    About,
    Contact
  },
  watch: {
    $route(to) {
      let dest = to.name === "home" ? 0 : `#${to.name}`;
      this.$vuetify.goTo(dest, {
        duration: 500,
        offset: -1,
        easing: "easeOutCubic"
      });
    }
  }
})
export default class Home extends Vue {}
